import { createVueComponent, getVueDeps } from "./vue";

async function init(){
  const buttons = document.querySelectorAll('.js-Modal');

  if ( !buttons.length ) return;

  const { components } = await getVueDeps(); 
  const modal = await createVueComponent(components.Modal, { 
    show: false,
    onClose: () => {
      modal.props.show = false;
    }
  });

  modal.instance.mount(
    document.createDocumentFragment('div')
  );

  function handleClick(e) {
    e.preventDefault();

    const button = e.target;
    const { icon, title, content } = button.dataset;

    modal.props.icon = icon;
    modal.props.title = title;
    modal.props.content = content;
    modal.props.show = true;
  }  

  buttons.forEach(button => button.addEventListener('click', handleClick));
}

init();
